import { Button } from '../../components/ui/button';
import { LumynProgress } from '../../components/common/LumynProgress';
import { ChevronLeft, ChevronRight, Flame, Loader2 } from 'lucide-react';

export function PlayerFooter({
  currentIndex, totalSlides, sectionIdx, totalSections,
  onPrev, onNext, allSlides, launchingLive,
}) {
  const progressPct = totalSlides > 0 ? ((currentIndex + 1) / totalSlides) * 100 : 0;
  const nextIsQuiz = currentIndex < totalSlides - 1 && allSlides[currentIndex + 1]?.type === 'quiz';
  const disableNext = currentIndex >= totalSlides - 1 && allSlides[currentIndex]?.type !== 'quiz';

  return (
    <div className="h-16 border-t flex items-center justify-between px-6 shrink-0 bg-card">
      <Button variant="outline" size="sm" onClick={onPrev} disabled={currentIndex === 0} data-testid="prev-btn">
        <ChevronLeft className="w-4 h-4 mr-1" /> Previous
      </Button>
      <div className="flex-1 mx-8 space-y-1">
        <LumynProgress value={progressPct} size="thin" />
        <p className="text-xs text-center text-muted-foreground">
          {currentIndex + 1} / {totalSlides} &bull; Section {sectionIdx + 1} of {totalSections}
        </p>
      </div>
      <Button
        size="sm"
        onClick={onNext}
        disabled={disableNext || launchingLive}
        data-testid="next-btn"
        className={nextIsQuiz ? 'bg-[var(--lumyn-live)] hover:bg-[var(--lumyn-live)]/90 text-white' : ''}
      >
        {nextIsQuiz ? (
          <>
            {launchingLive
              ? <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              : <Flame className="w-4 h-4 mr-1" />}
            Start Live Quiz
          </>
        ) : (
          <>Next <ChevronRight className="w-4 h-4 ml-1" /></>
        )}
      </Button>
    </div>
  );
}
